<template>
    <app-dialog v-if="dialogShow" customClass="assistantDialog"
                width="60%"
                @onCancel="dialogCancel">
        <template slot="title">
            <span class="assistantDialog_title">业务模型</span>
            <span class="assistantDialog_title2">(贴合业务场景的AI模型，赋能业务智能化)</span>
        </template>
        <AppPaginationLayout :total="total"
                             v-loading="loading"
                             element-loading-text="查询中，请稍后"
                             element-loading-spinner="el-icon-loading"
                             element-loading-background="rgba(255, 255, 255, 0.32)"
                             :searchKey.sync="queryForm.searchKey"
                             searchPlaceholder="查找模型"
                             :pageSize.sync="queryForm.pageSize"
                             :pageNo.sync="queryForm.pageNo"
                             @queryList="getList">
            <template slot="header">
                <el-select v-model="queryForm.assistantId"
                           @change="getList"
                           filterable clearable placeholder="请选择应用">
                    <el-option
                        v-for="item in assistantOptions"
                        :key="item.assistantId"
                        :label="item.assistantName"
                        :value="item.assistantId">
                    </el-option>
                </el-select>
            </template>
            <template slot="content">
                <el-table customClass="addNewKnowledgeDialog"
                          class="table-list" :data="tableData"
                          header-row-class-name="header-table"
                          ref="tableList"
                          height="100%">
                    <template v-for="item in tableFiled">
                        <el-table-column :key="item.code" v-if="item.code === 'operate'"
                                         fixed="right"
                                         class-name="operate-table-item" label="操作" :width="item.width">
                            <template slot-scope="scope">
                                <template v-for="(btn, index) in item.btnList">
                                    <template v-if="!(Number(scope.row['knowledgeType']) === 2 && btn.code === 'createDraft')">
                                    <span :key="scope.row['documentId'] + btn.code + '-line'"
                                          v-if="index > 0 && index < item.btnList.length" class="operate-line"></span>
                                        <el-button :key="scope.row['documentId'] + btn.code" type="text"
                                                   @click="handleTableOperate(btn.code, scope.row)">{{btn.label}}</el-button>
                                    </template>
                                </template>
                            </template>
                        </el-table-column>
                        <el-table-column v-else :width="item.width" :minWidth="item.minWidth" :key="item.code"
                                         :prop="item.code" :label="item.label">
                            <template slot-scope="scope">
                                <el-popover :disabled="!item.needPopover" popper-class="popper-wrapper"
                                            trigger="hover" placement="top">
                                    <div class="popover-content">{{scope.row[item.code]}}</div>
                                    <div slot="reference" class="text-overflow table-item-cell empty-separator">
                                        <template v-if="item.code === 'knowledgeType'">
                                            {{ Number(scope.row[item.code]) === 1 ? '文档' : '问答对' }}
                                        </template>
                                        <template v-else>{{ scope.row[item.code] }}</template>
                                    </div>
                                </el-popover>
                            </template>
                        </el-table-column>
                    </template>
                </el-table>
            </template>
        </AppPaginationLayout>
    </app-dialog>
</template>

<script>
import AppDialog from '../AppDialog';
import AppPaginationLayout from '../AppPaginationLayout';
export default {
    name: 'assistant-dialog',
    components: {
        AppDialog,
        AppPaginationLayout
    },
    data () {
        return {
            dialogShow: false,
            loading: false,
            total: 0,
            queryForm: {
                assistantId: '',
                searchKey: '',
                pageNo: 1,
                pageSize: 10
            },
            tableData: [],
            tableFiled: [
                {
                    label: '应用',
                    code: 'assistantName',
                    width: 180,
                    needPopover: true
                },
                {
                    label: '模型名称',
                    code: 'modelName',
                    width: 180,
                    needPopover: true
                },
                {
                    label: '模型描述',
                    code: 'modelDesc'
                },
                {
                    label: '操作',
                    code: 'operate',
                    width: 80,
                    btnList: [
                        {
                            label: '对话',
                            code: 'assistantChat'
                        }
                    ]
                }
            ],
            assistantOptions: []
        };
    },
    mounted () {
        this.getAssistantList();
        this.getList();
    },
    methods: {
        showDialog () {
            this.dialogShow = true;
        },
        getAssistantList () {
            this.$api.knowledgeApi.getAssitantList().then((res) => {
                let response = res.data;
                this.assistantOptions = [{
                    assistantId: '',
                    assistantName: '全部应用'
                }].concat(response.data) || [];
            });
        },
        getList () {
            let params = {
                assistantId: this.queryForm.assistantId,
                modelName: this.queryForm.searchKey,
                pageNo: this.queryForm.pageNo,
                pageSize: this.queryForm.pageSize
            };
            this.loading = true;
            this.$api.knowledgeApi.getBusinessModelList(params).then((res) => {
                let response = res.data;
                this.total = response.total;
                this.tableData = response.data || [];
                this.loading = false;
            });
        },
        // 处理表格操作事件
        handleTableOperate (type, row) {
            switch (type) {
                // 问答
                case 'assistantChat':
                    this.$emit('assistantChat', {
                        ...row,
                        isAssistant: true
                    });
                    this.dialogCancel();
                    break;
            }
        },
        dialogCancel () {
            this.dialogShow = false;
        }
    }
};
</script>

<style lang="scss">
.assistantDialog {
    height: 70%;
    .assistantDialog_title {
        font-weight: bolder;
        font-size: 18px;
    }
    .assistantDialog_title2 {
        font-size: 14px;
        margin-left: 8px;
    }
    .app-pagination-layout {
        .el-input__inner {
            border-color: rgba(0,0,0,0.15);
        }
        .el-input__inner:hover, .el-input__inner:focus {
            border-color: rgba(18, 108, 255,0.65);
        }
    }
}
</style>
